import React, { ComponentState, useEffect, useState } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { useSelector } from "react-redux";
import { Paper, Typography } from '@mui/material';
import { clientChartModel } from 'src/dataModels/docListModel';
import { totalHoursAndMinutes } from 'src/util/utility';


const ClientDocumentsChart = () => {
    const state: ComponentState = useSelector(states => {
        return states;
    });
    const isBillingManager = state.getRolePermission.isBillingManager
    const [chartData, setChartData] = useState<clientChartModel[]>([])
    const { documentClientChartListResp } = state['DocumentReducer'];
    // Calculate the number of documents per client member

    useEffect(() => {
        setChartData([])
        if (documentClientChartListResp && documentClientChartListResp?.resultData) {
            // Sort the data by 'totDocs' in descending order
            const sortedData = documentClientChartListResp?.resultData?.slice().sort((a, b) => b.totDocs - a.totDocs);
            // Get the top 10 client members with the most 'totDocs'
            const topClient = sortedData?.slice(0, 20);
            topClient?.map((item) => {
                const minutes = totalHoursAndMinutes(item?.totalMinutes)
                const totalbillValue = Number(item?.totalBilled).toFixed(2);
                const formattedTotalBill = new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'USD'
                }).format(Number(totalbillValue));
                const label = `Docs: ${item?.totDocs}, Time: ${minutes} ${isBillingManager ? ", Billed Amt:" + " " + formattedTotalBill : ""}`
                var obj: clientChartModel = { clientName: item?.clientName, documents: item?.totDocs, info: label }
                setChartData((oldItem) => [...oldItem, obj])
            })
        }
    }, [documentClientChartListResp])

    // Find the client member with the most documents
    const mostDocumentsClient = chartData[0];
    const mostDocumentsCount = mostDocumentsClient ? mostDocumentsClient.documents : 0;

    return (
        <>
            {
                documentClientChartListResp?.resultData != 0 ?
                    <Paper elevation={3} style={{ padding: '20px 0' }}>
                        <Typography variant="h6" style={{ fontSize: 15 }}>
                            Client with most documents: {mostDocumentsClient?.clientName} ({mostDocumentsClient?.info})
                        </Typography>
                        <ResponsiveContainer width="100%" height={400}>
                            <BarChart data={chartData}>
                                <CartesianGrid stroke="transparent" strokeWidth={0} />
                                <XAxis dataKey="clientName" />
                                <YAxis />
                                <Tooltip 
                                 cursor={false}
                                content={(props) => {
                                    const { payload } = props;
                                    if (payload && payload.length > 0) {
                                        const dataItem = payload[0].payload; // Extract the data item
                                        return (
                                            <div className="custom-tooltip">
                                                <p>{dataItem.clientName}</p>
                                                <p>{dataItem.info}</p>
                                            </div>
                                        );
                                    }
                                    return null;
                                }} />
                                <Legend />
                                <Bar dataKey="documents" fill="#02B2AF" />
                            </BarChart>
                        </ResponsiveContainer>
                    </Paper>

                    : ""
            }
        </>
    );
};

export default ClientDocumentsChart;
